module.exports = __webpack_public_path__ + "img/top-image02@2x.92f881ed.png";